import {useCallback} from 'react';
import {useAgentChatContext} from '../context/AgentChatContext';
import {useCampaignRuntimeContext} from '../context/CampaignRuntimeContext';
import {submitInteractiveWidgetCompletion} from '../domain/interactiveWidgetSubmission';

/**
 * Honest widget submission: tracks pending state until backend confirms completion.
 */
export default function useInteractiveWidgetSubmit(
  toolName,
  toolCallId,
  completionMessage,
) {
  const {sendMessage, isLoading} = useAgentChatContext();
  const {pendingSubmissions, registerPendingSubmission, clearPendingSubmission} =
    useCampaignRuntimeContext();

  const isPending = toolCallId ? Boolean(pendingSubmissions[toolCallId]) : false;

  const handleSubmit = useCallback(
    (completedData = {}) =>
      submitInteractiveWidgetCompletion({
        toolCallId,
        isLoading,
        isPending,
        sendMessage,
        registerPendingSubmission,
        clearPendingSubmission,
        completionMessage,
        completedData,
      }),
    [
      isLoading,
      isPending,
      toolCallId,
      completionMessage,
      sendMessage,
      registerPendingSubmission,
      clearPendingSubmission,
    ],
  );

  return {
    handleSubmit,
    isPending,
    clearPending: clearPendingSubmission,
  };
}
